import React from 'react';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/common/card.scss';

export const Card = props => {
  const { testId } = useMartyContext();
  const { children } = props;
  const onlyImage = Array.isArray(children) && children.filter(v => v && (v.type.name === 'CardMedia' || v.type.name === 'Link')).length || children?.type?.name === 'CardMedia';

  return (
    <article
      className={cn(css.card, { [css.onlyImage]: onlyImage })}
      itemScope
      itemType="http://schema.org/Product"
      data-test-id={testId('searchResult')}>
      {children}
    </article>
  );
};

export default Card;

